import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { AccessibilityTabs, AccessibilityTab, AccessibilityTabContent, AccessibilityClickableDiv, AccessibilityHiddenImg } from '@skillz/accessibility';
import ScrollLTR from "../scrollLTR/ScrollLTR";
import closeIcon from "../../../assests/icons/close.png";
import useClickOutside from "../../../hooks/useClickOutside";
import classes from "./TabsMenu.module.css";

const TabsMenu = ({ startTabIndex, children, contentHeight, onDisabledClick, tabWidth, tabHeight, dropClassTabsMenu, dropClassMenu, toggleContent, dropClassScrollLTR, enableClickOutside, showClose, tabImgColor, tabsName, accessibilityDescription, tabsStyle, hideTabsTextResp, useSearchParams, dropClassScrollContent,downDropStyle }) => {

    const { texts } = useSelector(state => state.translate);
    const tabRef = useRef(null);
    const [currentTab, setCurrentTab] = useState(-1);
    const [showContent, setShowContent] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const menuTabsId = `${tabsName}-tabs`;

    useEffect(() => {
        // to do shulamit check in accessibility package
        const tabsElemParent = document.querySelector(`#${menuTabsId}`)?.parentElement;
        tabsElemParent.querySelector('[role="tabpanel"]')?.removeAttribute("hidden");
    }, [menuTabsId, currentTab]);

    useEffect(() => {
        if (currentTab === -1) {
            startTabIndex ? setCurrentTab(startTabIndex) : setCurrentTab(0)
        }
        toggleContent ? startTabIndex >= 0 ? setShowContent(true) : setShowContent(false) : setShowContent(true)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, startTabIndex, toggleContent])

    const handleClick = (e, tab, index) => {
        e.stopPropagation()
        if (tab.props.disabeled)
            onDisabledClick && onDisabledClick()
        else {
            if (toggleContent) {
                if (currentTab === index) {
                    setShowContent(false)
                    setCurrentTab(-1)
                }
                else {
                    setShowContent(true)
                    setCurrentTab(index)
                }
            }
            else
                setCurrentTab(index)
        }
    }

    useEffect(() => {
        if (useSearchParams && currentTab > -1) {
            navigate(`?tab=${children[currentTab].props.name}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentTab])

    useEffect(() => {
        if (useSearchParams && startTabIndex > -1) {
            setCurrentTab(startTabIndex);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startTabIndex])

    useClickOutside(tabRef, () => {
        if (enableClickOutside) {
            setShowContent(false)
            setCurrentTab(-1)
        }
    });

    const close = () => {
        setShowContent(false);
        setCurrentTab(-1);
    }

    return (
        <AccessibilityTabs id={menuTabsId} accessibilityDescription={accessibilityDescription} menu={toggleContent}>
            <div className={`${classes.TabsMenu} ${dropClassTabsMenu}`}>
                <div id={menuTabsId} className={`${classes.Menu} ${dropClassMenu}`} style={{ gap: tabsStyle?.gap && `${tabsStyle?.gap}px` }}>
                    {children && children.map((tab, index) =>
                        <AccessibilityTab key={index}
                            id={`${tabsName}-${index}`}
                            selected={currentTab === index}
                            hidden={tab.props.hidden}
                            onClick={(e) => handleClick(e, tab, index)}
                            menu={toggleContent}
                            className={`${classes.MyTab} ${classes.MyTab} ${tab.props.dropClass} ${currentTab === index && classes.SelectTab} ${tab.props.disabeled ? classes.Disabeled : ''}`}
                            style={{ width: tabWidth, height: tabHeight }}>
                            <div>
                                <div ref={tabRef} className={`${classes.TabContent} ${tab.props.dropClassTabContent}`}>
                                    {tab.props.img && <AccessibilityHiddenImg className={`${classes.TabImg} ${tabImgColor && classes.TabImgColor}`} src={tab.props.img} />}
                                    {tab.props.text ? <p className={`${!hideTabsTextResp ? classes.TabText : ""} ${tabsStyle?.hideTabText === true ? classes.HideTabText : tabsStyle?.hideTabText === false ? classes.DisplayTabText : ""}`}>{tab.props.text}</p> : ''}
                                </div>
                                <div style={{ backgroundColor: currentTab === index && tab.props.selectedColor }} className={classes.LineBorder}></div>
                            </div>
                        </AccessibilityTab>
                    )}
                </div>
                {showContent && children &&
                    <AccessibilityTabContent
                        hidden={false}
                        menu={toggleContent}
                        id={`${tabsName}-${currentTab}`}>
                        <div className={`${classes.ScrollContent} ${dropClassScrollContent}`}>
                            <ScrollLTR height={contentHeight} downDropStyle={downDropStyle} dropClass={dropClassScrollLTR}>
                                {showClose &&
                                    <div className={classes.CloseTabs}>
                                        {/* <Tooltip text={texts.close} showTooltip={false}> */}
                                        <AccessibilityClickableDiv accessibilityDescription={texts.close} onClick={close}>
                                            <AccessibilityHiddenImg src={closeIcon} />
                                        </AccessibilityClickableDiv>
                                        {/* </Tooltip> */}
                                    </div>
                                }
                                {children[currentTab]?.props.children}
                            </ScrollLTR>
                        </div>
                    </AccessibilityTabContent>
                }
            </div>
        </AccessibilityTabs>
    )
}

const Tab = ({ name, text, disabeled, img, selectedColor, dropClassTabContent, dropClass, accessibilityDescription, hidden = false }) => { }

export { TabsMenu, Tab };